module.exports = __webpack_public_path__ + "img/vip-bg.79da8137.jpg";